
<template>
  <v-list-item class="pl-1">
    <v-btn
      class="subtitle-1 text-none pl-0 ml-0"
      color="red"
      active-class="underline"
      type="submit"
      title="Выйти"
      text
      @click="closeDialog"
      plain
      @click.stop="exitClicked = true"
    >
      Выход
      <confirm-exit-dialog v-model="exitClicked"></confirm-exit-dialog>
    </v-btn>
  </v-list-item>
</template>


<script>
import ConfirmExitDialog from "./ConfirmExitDialog.vue";
export default {
  components: {
    ConfirmExitDialog,
  },
  data: () => ({
    exitClicked: false,
  }),
  methods: {
    closeDialog: function () {
      // console.log("Closed");
      this.$emit("close-dialog");
    },
  },
};
</script>
